import { ActiveDirectoryComponent } from './active-directory/active-directory.component';
import { ActiveDirectoriesComponent } from './active-directories.component';
import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from 'ngx-clipboard';
import { BnsightsLibraryModule } from 'bnsights-control-library';
import { BlockUIModule } from 'ng-block-ui';
import { AuthModule } from '../core/auth.module';
import { ActiveDirectoryRoutingModule } from './active-directory-routing.module';
import { SubheaderModule } from '../_layout/components/subheader/subheader.module';
import { ActiveDirectoryAddComponent } from './active-directory-add/active-directory-add.component';
import { MatMenuModule } from '@angular/material/menu';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { EmptyDataModule } from '../empty-data/empty-data.module';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bnsights-utilities-library';
import { ActiveDirectoryService } from '../shared/Services/ActiveDirectoryService.service';


@NgModule({
  declarations: [ActiveDirectoryComponent, ActiveDirectoriesComponent, ActiveDirectoryAddComponent],
  imports: [
    ActiveDirectoryRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    AuthModule,
    RouterModule,
    CommonModule,
    ClipboardModule,
    BlockUIModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    BnsightsLibraryModule,
    SubheaderModule,
    MatMenuModule,
    InlineSVGModule,
    NgbModule,
    EmptyDataModule

  ],
  providers: [
    EnvironmentService,
    UtilityService,
    AuthService,
    BBSFTranslateService, 
    ActiveDirectoryService
  ]

})
export class ActiveDirectoryModule { }
